import get from 'lodash/get';
import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';

import './adaptive-carousel_mobile.scss';

interface Props {
    initialItemIndex: number;
    children: Array<React.ReactElement> | React.ReactElement | null;
}

export class AdaptiveCarouselMobile extends React.Component<Props> {
    componentDidMount() {
        this.setInitialScroll();
    }

    itemRefs: Array<React.ReactInstance | null> = [];
    contentRef: HTMLDivElement;

    onItemRef = (ref: React.ReactInstance | null, itemIndex: number) => {
        this.itemRefs[itemIndex] = ref;
    };

    setContentRef = (ref: HTMLDivElement | null) => {
        if (ref) {
            this.contentRef = ref;
        }
    };

    setInitialScroll = () => {
        const { initialItemIndex } = this.props;

        if (initialItemIndex) {
            const targetItem = get(this.itemRefs, initialItemIndex);
            const newScrollValue = Math.abs(get(ReactDOM.findDOMNode(targetItem), 'offsetLeft', 0));

            this.contentRef.scrollTo({ left: newScrollValue, behavior: 'smooth' });
        }
    };

    render() {
        const { children } = this.props;

        return (
            <div className="adaptive-carousel">
                <div className="adaptive-carousel__content" ref={this.setContentRef}>
                    {children &&
                        React.Children.map<ReactElement, ReactElement>(children, (itemElement, itemIndex) =>
                            React.cloneElement(itemElement, {
                                ref: (ref: React.ReactInstance) => {
                                    this.onItemRef(ref, itemIndex);
                                },
                            })
                        )}
                </div>
            </div>
        );
    }
}

export default AdaptiveCarouselMobile;
